import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { FormControl } from "@angular/forms";

import { CommonJS } from '../../functions';

@Component({
    moduleId: module.id,
    selector: 'angular-datepicker',
    templateUrl: 'angular-datepicker.html',
    styleUrls: ['angular-datepicker.css'],
    encapsulation: ViewEncapsulation.None
})
export class AngularDatepickerComponent implements OnChanges {

    showPicker: boolean = false;
    innerValue: Date;
    @Input() data: Date = new Date();
    @Input() minDate: Date = null;
    @Input() maxDate: Date = null;
    @Input() minMode: string = 'day';
    @Input() datepickerMode: string = 'day';
    @Input() shownDateFormat: string = "dd/mm/yyyy";
    @Input() width: string = '150px';
    @Input() disabled: boolean = false;
    @Input() readOnly: boolean = false;    
    @Input() inputId: string = '';
    @Input() inputStyle = null;
    @Input() dayDisabled = [];
    @Output() dataChange = new EventEmitter();
    @Output() onShown = new EventEmitter();
    @Output() onHidden = new EventEmitter();

    ngOnChanges(changes: SimpleChanges): void {       
        if (changes["data"] ) {
            if (this.data) {
                let temp: Date = new Date(this.data);
                if (temp.getTime() == -62135600400000) this.innerValue = null;
                else  this.innerValue = temp;
            }
            else this.innerValue = null;
        }
    }

    dateToString() {
        if (this.innerValue) return CommonJS.dateCustomFormat(this.innerValue, this.shownDateFormat);
        else return "";
    }

    toggle() {
        this.showPicker = !this.showPicker;
        if (this.showPicker) this.onShown.emit();
        else this.onHidden.emit();
    }

    show() {
        this.showPicker = true;
        this.onShown.emit();
    }

    hide() {
        this.showPicker = false;
        this.onHidden.emit();
    }

    selected(value: any) {
        this.innerValue = new Date(value);
        this.dataChange.emit(this.innerValue);
        this.showPicker = false;
        this.onHidden.emit();
    }

    empty() {
        this.innerValue = null;
        this.dataChange.emit(this.innerValue);
    }
}


// WEBPACK FOOTER //
// ./src/angular_library/components/datepicker/angular-datepicker.component.ts